<template>
  <div class>
    <!-- header start -->
    <van-nav-bar
      title="我的团队"
      fixed
      :z-index="99"
      left-arrow
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <van-tabs
      sticky
      offset-top="46"
      title-active-color="#fff"
      title-inactive-color="#f2f2f2"
      background="#24a378"
      color="#fff"
      :border="false"
    >
      <van-tab title="直推会员">
          <team_list :RelationStatus=0 ></team_list>
      </van-tab>
      <van-tab title="间接会员">
        <team_list :RelationStatus=1 ></team_list>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import team_list from "@/components/team_list";
export default {
  data() {
    return {};
  },
  components: {
    team_list
  },
  mounted() {
    var _query=this.$route.query;
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f2f2f2");
 
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>

</style>
